import { Paper } from '@material-ui/core';
import MaterialTooltip from '@material-ui/core/Tooltip';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import React from 'react';
import './image-tooltip.css';
const LightTooltip = withStyles((theme) => ({
    tooltip: {
        backgroundColor: theme.palette.common.white,
        boxShadow: theme.shadows[1],
        fontSize: 14,
        width: '755px',
        color: '#635BFF',
        opacity: 1
    },
    arrow: {
        color: 'white'
    }
}))(MaterialTooltip);
const useTooltipStyles = makeStyles(() => ({
    header: {
        background: '#635BFF',
        marginBottom: '8px'
    },
    headerContent: {
        backgroundColor: '#635BFF',
        borderRadius: 5,
        color: 'white',
        fontSize: 16,
        fontWeight: 600,
        paddingLeft: '10px',
        padding: '5px'
    }
}));
const TooltipContent = ({ id, country, state, type, version }) => {
    const classes = useTooltipStyles();
    const rows = [
        { key: 'ID:', value: id },
        { key: 'COUNTRY:', value: country },
        { key: 'STATE:', value: state },
        { key: 'TYPE:', value: type },
        { key: 'VERSION:', value: version }
    ].filter((row) => !!row.value);
    return (React.createElement("div", null,
        React.createElement(Paper, { className: classes.header, elevation: 3 },
            React.createElement("div", { className: classes.headerContent }, "Job image detail")),
        rows.map((data) => (React.createElement("div", { className: "tooltip-row", key: data.key },
            React.createElement("div", null, data.key),
            React.createElement("div", null, data.value))))));
};
export const ImageTooltip = ({ id, country, state, type, version, disable = false, children }) => {
    return (React.createElement(LightTooltip, { disableHoverListener: disable, interactive: true, placement: "bottom-start", title: React.createElement(TooltipContent, { country: country, id: id, state: state, type: type, version: version }) }, children));
};
